let swiper = new Swiper(".mySwiper", {
    slidesPerView: 2,
    spaceBetween: 15,
    centeredSlides: false,
    slidesPerGroup: 2,

    navigation: {
        nextEl: ".swiper-btn--next",
        prevEl: ".swiper-btn--prev",
      },
  });

  (function () {
    $('.timeline').children('.timeline-container').children('.content').children('p').first().css('display', 'block')
    $('.timeline').children('.timeline-container').first().addClass('active')
	const initTimelineContent = () => {

		$('.timeline-container').unbind("click").on('click', function() {
			const parent = $(this).parent();

            $('.timeline-container').children('.content').children('p').stop().slideUp('slow')
            $('.timeline-container').removeClass('active')

            if (!$(this).children('.content').children('p').css('display', 'none')) {

                $(this).children('.content').children('p').stop().slideUp('slow')
                $(this).removeClass('active')
        
            }  else {
              
                $(this).children('.content').children('p').stop().slideUp('slow')
                $(this).addClass('active')
            } 

            $(this).children('.content').children('p').slideDown("slow")
            $(this).addClass('active')
        
		});
	};

	document.addEventListener('shopify:section:load', function () {
		initTimelineContent();
	});

	initTimelineContent();
})();
